export default __webpack_public_path__ + "708d7ae05c34c65f6b7304374adb5656.jpg";